import React from "react";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import logo from '../../images/logo.png'
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  SettingsOutlined,
  ChevronLeft,
  ChevronRightOutlined,
  HomeOutlined,
  ShoppingCartOutlined,
  Groups2Outlined,
  ReceiptLongOutlined,
  PublicOutlined,
  PointOfSaleOutlined,
  TodayOutlined,
  CalendarMonthOutlined,
  AdminPanelSettingsOutlined,
  TrendingUpOutlined,
  PieChartOutlined,
} from "@mui/icons-material";
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../../theme";
const { styled } = require("@mui/system");

const FlexBetween = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});


const navItems = [
  {
    text: "Dashboard",
    icon: <HomeOutlined />,
  },
  {
    text: "Client Facing",
    icon: null,
  },
  {
    text: "Employes",
    icon: <Groups2Outlined />,
  },
  {
    text: "Assets",
    icon: <ReceiptLongOutlined />,
  },
  {
    text: "projects",
    icon: <ReceiptLongOutlined />,
  },
  {
    text: "AddGallery",
    icon: <ReceiptLongOutlined />,
  },

  {
    text: "Management",
    icon: null,
  },
  {
    text: "admin",
    icon: <AdminPanelSettingsOutlined />,
  }
];

const Sidebar = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)");

  const { pathname } = useLocation();
  const [active, setActive] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.mode);

  const handleClick = () => {
    console.log('Fwd btn click');
    setIsSidebarOpen(true)
  }
  const sidebarRef = useRef(null);
  useEffect(() => {
    setActive(pathname.substring(1));
  }, [pathname]);

  const handleCloseSidebar = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsSidebarOpen(false);
    }
  };


  useEffect(() => {
    // Add event listener when the component mounts
    document.addEventListener("click", handleCloseSidebar);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleCloseSidebar);
    };
  }, []);
  const handleSidebarItemClick = (text) => {
    navigate(`/${text.toLowerCase()}`);
    setActive(text.toLowerCase());
    setIsSidebarOpen(false); // Close the sidebar when a sidebar item is clicked
  }

  return (
    <Box component="nav" ref={sidebarRef} >
      <ArrowForwardIcon onClick={handleClick} style={{ margin: "2rem",cursor: "pointer",  }} />
      {isSidebarOpen && (
        <Drawer
          open={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: "250px",
            "& .MuiDrawer-paper": {
              color: colors.secondary[200],
              backgroundColor: colors.blueAccent[100],
              boxSixing: "border-box",
              boxShadow: "5px 0 5px rgba(0, 0, 0, 0.1)",
              borderWidth: isNonMobile ? 0 : "2px",
              width: "250px",
            },
          }}
        >
          <Box width="100%">
            <img src={logo}
              alt="logo"
              style={{ width: "4rem", height: "4rem", cursor: "pointer",marginLeft: "5rem",marginTop: '2rem' }}
              onClick={() => navigate("/")} />
            <Box m="1.5rem 2rem 2rem 3rem">
              <FlexBetween color={colors.secondary[100]}>
                <Box display="flex" alignItems="center" gap="0.5rem">
                  <Typography variant="h4" fontWeight="bold">
                    Skyline
                  </Typography>
                </Box>
                {!isNonMobile && (
                  <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)} style={{ color: "#ffe3a3" }}>
                    <ChevronLeft  style={{cursor: "pointer"}}/>
                  </IconButton>
                )}
              </FlexBetween>
            </Box>
            <List>
              {navItems.map(({ text, icon }) => {
                if (!icon) {
                  return (
                    <Typography key={text} sx={{ m: "2.25rem 0 1rem 3rem" }}
                      onClick={() => handleSidebarItemClick(text)} // Close sidebar on click

                    >
                      {text}
                    </Typography>
                  );
                }
                const lcText = text.toLowerCase();

                return (
                  <ListItem key={text} disablePadding>
                    <ListItemButton
                      onClick={() => {
                        navigate(`/${lcText}`);
                        setActive(lcText);
                        handleSidebarItemClick(text)
                      }}
                      sx={{
                        backgroundColor:
                          active === lcText
                            ? colors.secondary[300]
                            : "transparent",
                        color:
                          active === lcText
                            ? colors.primary[600]
                            : colors.secondary[100],
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          ml: "2rem",
                          color:
                            active === lcText
                              ? colors.primary[600]
                              : colors.secondary[200],
                        }}
                      >
                        {icon}
                      </ListItemIcon>
                      <ListItemText primary={text} />
                      {active === lcText && (
                        <ChevronRightOutlined sx={{ ml: "auto" }} />
                      )}
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Box>

          <Box position="absolute" bottom="2rem">
            <Divider />
            <FlexBetween textTransform="none" gap="1rem" m="1.5rem 2rem 0 3rem">

              <Box textAlign="left">
                {/* <Typography
                  fontWeight="bold"
                  fontSize="0.9rem"
                  sx={{ color: colors.secondary[100] }}
                >
                 Airaj Siddiqui
                </Typography>
                <Typography
                  fontSize="0.8rem"
                  sx={{ color: colors.secondary[200] }}
                >
                  Skyline
                </Typography> */}
              </Box>

            </FlexBetween>
          </Box>
        </Drawer>
      )}
    </Box>
  );
};

export default Sidebar;
